import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./layout/MainLayout";

import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import AdminRoute from "./routes/AdminRoute";
import Admins from "./pages/Admins";
import Drivers from "./pages/Drivers";
import Clients from "./pages/Clients";
import OrderTypes from "./pages/OrderTypes";
import Documents from "./pages/Documents";
import Trips from "./pages/Orders";
import Wallet from "./pages/Wallet";
import Transactions from "./pages/Transactions";
import NewsLetters from "./pages/NewsLetters";
import { useToast } from "./context/ToastContext";
import Plaintes from "./pages/Plaintes";
import Cars from "./pages/Cars";
import OrderDetailsPage from "./components/order/OrderDetailsPage";
import PlainteDetailsPage from "./components/plainte/PlainteDetailsPage";
import Promos from "./pages/Promos";
import PromoDetailsPage from "./components/promo/PromoDetailsPage";


function Placeholder({ title }) {
  return <div style={{ fontWeight: 900, fontSize: 22 }}>{title}</div>;
}

export default function App() {

  const { showToast } = useToast();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <AdminRoute>
            <MainLayout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/admins" element={<Admins />} />
                <Route path="/drivers" element={<Drivers/>} />
                <Route path="/clients" element={<Clients/>} />
                <Route path="/order-types" element={<OrderTypes/>} />
                <Route path="/documents" element={<Documents/>} />
                <Route path="/rides" element={<Trips/>} />
                <Route path="/rides/:id" element={<OrderDetailsPage />} />
                <Route path="/transactions" element={<Transactions/>} />
                <Route path="/newsletter" element ={<NewsLetters/>}/>
                <Route path="/wallet" element={<Wallet />} />
                <Route path="/plaintes" element={<Plaintes />}/>
                <Route path="/plaintes/:id" element={<PlainteDetailsPage />} />
                <Route path="/promotions" element={<Promos/>}/>
                <Route path="/promotions/:id" element={<PromoDetailsPage />} />
                <Route path="/cars" element={<Cars/>} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/cars" element={<Cars/>} />
                <Route path="/profile" element={<Profile />} />
              </Routes>
            </MainLayout>
            </AdminRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
